import { FC } from "react";
import { Control, Controller, RegisterOptions } from "react-hook-form";

import { Action } from "shared/components";
import { FlexContainer } from "shared/styles";
import { IFormOption } from "shared/types";

import { FieldWrapper, FieldWrapperProps } from "../FieldWrapper";
import { ActionWithOptions } from "shared/components/ActionWithOptions/ActionWithOptions";
import { EventBlocksType } from "Bands/types";

type TagValue =
  | string
  | {
      [key in `${EventBlocksType}`]: string;
    };

export interface TagGroupProps extends FieldWrapperProps {
  control: Control;
  validation?: RegisterOptions;
  defaultValue?: string;
  options: IFormOption[];
  isMultiple?: boolean;
  onChange?: any;
  showViewLabel?: boolean;
}

export const TagGroup: FC<TagGroupProps> = ({
  options,
  name,
  control,
  defaultValue,
  validation,
  isMultiple,
  showViewLabel,
  onChange: handleChange,
  ...rest
}) => {
  return (
    <FieldWrapper name={name} {...rest}>
      <FlexContainer size="xxs">
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          rules={validation}
          render={({ onChange, onBlur, value }) => (
            <>
              {options.map(option => {
                if (option.options?.length) {
                  return (
                    <ActionWithOptions
                      key={option.value}
                      {...option}
                      showViewLabel={showViewLabel}
                      isActive={
                        value !== undefined &&
                        (value === option.value ||
                          value.find((v: TagValue) => Object.keys(v).includes(option.value)))
                      }
                      handleClick={selectedOption => {
                        const selected = option.value;

                        if (!isMultiple) {
                          handleChange && handleChange(selected);
                          onChange(selected);
                          // Blur so validation updates
                          onBlur();
                          return;
                        }

                        let newValue = [];

                        const valueArray = value as TagValue[];

                        const isInArray = valueArray?.find(v => Object.keys(v).includes(selected));

                        if (isInArray) {
                          newValue = value?.filter(
                            (v: TagValue) => !Object.keys(v).includes(selected)
                          );
                        } else {
                          newValue = [...(value || []), { [selected]: selectedOption }];
                        }

                        handleChange && handleChange(newValue?.length === 0 ? undefined : newValue);
                        onChange(newValue?.length === 0 ? undefined : newValue);
                        // Blur so validation updates
                        onBlur();
                      }}
                      updateOption={(selectedOption: string) => {
                        const newValue = value?.map((v: TagValue) => {
                          if (Object.keys(v).includes(option.value)) {
                            return { [option.value]: selectedOption };
                          }
                          return v;
                        });

                        handleChange && handleChange(newValue?.length === 0 ? undefined : newValue);
                        onChange(newValue?.length === 0 ? undefined : newValue);
                        // Blur so validation updates
                        onBlur();
                      }}
                      options={option.options}
                    />
                  );
                }

                return (
                  <Action
                    key={option.value}
                    showViewLabel={showViewLabel}
                    {...option}
                    isActive={
                      value !== undefined &&
                      (value === option.value || value?.includes(option.value))
                    }
                    handleClick={() => {
                      const selected = option.value;

                      if (!isMultiple) {
                        handleChange && handleChange(selected);
                        onChange(selected);
                        // Blur so validation updates
                        onBlur();
                        return;
                      }

                      let newValue = [];

                      const valueArray = value as TagValue[];

                      const isInArray = valueArray?.includes(selected);

                      if (isInArray) {
                        newValue = value.filter((v: TagValue) => v !== selected);
                      } else {
                        newValue = [...(value || []), selected];
                      }

                      handleChange && handleChange(newValue?.length === 0 ? undefined : newValue);
                      onChange(newValue?.length === 0 ? undefined : newValue);
                      // Blur so validation updates
                      onBlur();
                    }}
                  />
                );
              })}
            </>
          )}
        />
      </FlexContainer>
    </FieldWrapper>
  );
};
